var map = {
	"./ritaSink.webp": 5136,
	"./ritaTabletop.webp": 3261,
	"./ritaWhole.webp": 739,
	"./ritaWhole2.webp": 1866,
	"./ritaWhole3.webp": 8029,
	"./ritaWhole4.webp": 6349,
	"./ritaWhole5.webp": 3539,
	"./shaunSink.webp": 1611,
	"./shaunWhole.webp": 7848,
	"./shaunWhole2.webp": 1936,
	"./shaunWhole3.webp": 3431,
	"./shaunWhole4.webp": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3895;